module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filteredItems == undefined) ? _c('div', {
    staticClass: "content-preload"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.filteredItems != undefined) ? _c('div', {
    staticClass: "view specs"
  }, [_c('box', {
    attrs: {
      "label": _vm.filteredItems.length + ' specs'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [(false) ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.createNewSpec()
      }
    }
  }, [_vm._v("Nyt spec")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Kunde"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.clients), function(client, client_key, client_i) {
    return _c('option', {
      domProps: {
        "value": client_key
      }
    }, [_vm._v(_vm._s(client.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.projects), function(project, project_key, project_i) {
    return _c('option', {
      domProps: {
        "value": project_key
      }
    }, [_vm._v(_vm._s(project.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.$store.state.specs.statuses), function(status, status_key, status_i) {
    return _c('option', {
      domProps: {
        "value": status_key
      }
    }, [_vm._v(_vm._s(status.title))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Søg"
    }
  }, [_c('input', {
    ref: "search_filter",
    attrs: {
      "type": "text",
      "placeholder": "Søg"
    },
    domProps: {
      "value": _vm.search_filter
    },
    on: {
      "keyup": _vm.search_filter_updated
    }
  })])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.filteredItems.length) ? _c('table', {
    staticClass: "table-a spec-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Spec")]), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Kunde")]), _vm._v(" "), _c('th', {
    staticClass: "align-r hide"
  }, [_vm._v("Tidsbudget")]), _vm._v(" "), (_vm.is_admin) ? _c('th', {
    staticClass: "_align-r"
  }, [_vm._v("Budget")]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Oprettet")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(spec, i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": spec
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/spec/' + spec.key
      }
    }, [(spec.title) ? [_vm._v(_vm._s(spec.title))] : _vm._e(), _vm._v(" "), (!spec.title) ? [_vm._v("Unavngiven")] : _vm._e()], 2)], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [(_vm.getProject(spec)) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + _vm.getProject(spec).key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getProject(spec).name) + "\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [(_vm.getClient(spec)) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + _vm.getClient(spec).key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getClient(spec).name) + "\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.is_admin) ? _c('td', {
      staticClass: "_align-r"
    }, [_vm._v("\n\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("money")(_vm.specGetBudget(spec), 0)) + " kr.\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(spec.created.split(' ')[0]) + "\n\t\t\t\t\t\t")])])
  }), 0)]) : _vm._e()], 2), _vm._v(" "), (false) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewSpec()
      }
    }
  }, [_vm._v("Nyt Spec")]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab6c636","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Specs.vue
// module id = 590
// module chunks = 1